module.exports = __webpack_public_path__ + "static/media/bi.1cdf5b67.svg";